import React, { useEffect, useState } from "react";

const VolunteersBanner = () => {
    return (
        <>
            <section className="call-to-action">

                <div className="image-layer lazy-image" data-bg="url('../assets/images/background/Sadqa-E-Jariya-volunteers.jpg')"></div>

                <div className="auto-container">
                    <div className="inner">
                        <div className="sec-title centered">
                        <div className="text">
                                <strong>
                                We would also like to promote volunteer work by creating a data base and allowing <br/> people to donate their quality time as a means of ongoing sadqa for them.
                                </strong>
                            </div>
                            <br/>
                            <h2>JOIN WITH US, YOUR INVOLVEMENT WILL MAKE THE WORLD <br/> A BETTER PLACE.</h2>
                            <div className="text">
                                <strong>
                                    [They will be asked], "What is [wrong] with you? Why do you not help each other?" Quran [37:25]
                                </strong>
                            </div>
                            <div className="link-box clearfix"><a href="/get-involved" className="theme-btn btn-style-three"><span className="btn-title">Donate Now</span></a>
                            {/* <a href="/get-involved" className="theme-btn btn-style-one"><span className="btn-title">Join Us Now</span></a> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    );
};

export default VolunteersBanner;